import Debouncer from "./Debouncer";

class ScrollMonitor {

    constructor () {
        this._debouncer = new Debouncer(this._update.bind(this));
        this._scroller = window;
        this._initialised = false;
        this._lastKnownScrollY = 0;
        this._callbacks = [];

        setTimeout(this._attachEvent.bind(this), 100);
    }

    /**
     * Attach callback to will get the "scrollY position" and the "scroll direction" as arguments
     *
     * @param method as string
     * @param object as object
     */
    attachCallback (method, object = {}) {
        this._callbacks.push({object: object, method: method});
    }

    _update () {
        const currentScrollY = this.getScrollY(),
            scrollDirection = currentScrollY > this._lastKnownScrollY ? 'down' : 'up';

        this._lastKnownScrollY = currentScrollY;

        if (this._callbacks.length) {
            this._callbacks.forEach((cb) => {
                !function (currentScrollY) {
                    cb.object[cb.method](currentScrollY, scrollDirection);
                }(currentScrollY, scrollDirection);

            });
        }
    }

    /**
     * Gets the Y scroll position
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY
     * @return {Number} pixels the page has scrolled along the Y-axis
     */
    getScrollY () {
        return (this._scroller.pageYOffset !== undefined)
               ? this._scroller.pageYOffset
               : (this._scroller.scrollTop !== undefined)
                 ? this._scroller.scrollTop
                 : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    }

    /**
     * Attaches the scroll event
     * @private
     */
    _attachEvent () {
        if (!this._initialised) {
            this._lastKnownScrollY = this.getScrollY();
            this._initialised = true;
            this._scroller.addEventListener('scroll', this._debouncer, false);
            this._debouncer.handleEvent();
        }
    }
}

export default ScrollMonitor;